import React, { useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import Tablenization from '@icoach/components/Tablenization';
import { CLUB_DOCUMENTS_ROUTER } from '@icoach/router/routerPath';
import { parseDate } from '@util/moment';
import { DateTimeStandard, Typography } from "@curves/ui-base";
import useDocMembershipTransferOutApi from '@apis/useDocMembershipTransferOutApi';
import { PEOPLE_TYPE } from '@icoach/constants/';
import { moreColData } from '@icoach/documents/components/moreColData';
import MembershipTransferOutDialogBox from '@icoach/documents/membership/transferOut/MembershipTransferOutDialogBox';
import { TRANSFEROUT_MOVETYPE } from '@icoach/constants/';
import { isEqual } from '@util/utils';

const isMoveoutTypeMap = [PEOPLE_TYPE.UNCONFIRMTRANSFEROUTMEMBER, PEOPLE_TYPE.ALREADYTRANSFEROUTMEMBER];

const rowsLabel = [
	{
		cellKey: 'applyDate',
		headerLabel: '申請時間',
		width: 20,
		formatCell: cellValue => parseDate(cellValue, DateTimeStandard.DisplayDateBySlash, false)
	},
	{
		cellKey: 'changeDate',
		headerLabel: '最後更新時間',
		width: 20,
		formatCell: cellValue => parseDate(cellValue, DateTimeStandard.DisplayFullBySlash, false)
	},
	{
		cellKey: 'isTemporary',
		headerLabel: '狀態',
		align: 'center',
		formatCell: (isTemporary, { isDeleted }) => {
			return isTemporary ? '暫存' : isDeleted ? '已刪除' : '已受理';
		}
	},
	{
		cellKey: 'transferOutClubText',
		headerLabel: '說明',
		align: 'center',
		className: 'white-space-normal',
		width: 30,
		formatCell: value => {
			return <Typography>{value}</Typography>;
		}
	},
	moreColData
];

const MembershipTransferOutHistoryTable = props => {
	const { className, sourceData = [], onReload } = props;
	const history = useHistory();
	const { peopleType: peopleTypeProps, referenceID: referenceIDProps } = useParams();
	const { deleteTransferOutContractApi, deleteDocTemporaryTransferOutContractApi, downloadTransferOutPDFApi } = useDocMembershipTransferOutApi();
	const membershipTransferOutDialogBoxRef = useRef(null);
	const labelTitle = useRef(rowsLabel);

	// 查看會籍移出合約 icon
	const handleReviewOnClick = ({ contractID }) => {
		let path;
		if (isMoveoutTypeMap.some(t => isEqual(t, peopleTypeProps))) {
			path = CLUB_DOCUMENTS_ROUTER.TRANSFEROUT.GET_READONLY_PATH(TRANSFEROUT_MOVETYPE.MOVEOUT, peopleTypeProps, referenceIDProps, contractID);
		} else {
			path = CLUB_DOCUMENTS_ROUTER.TRANSFEROUT.GET_READONLY_PATH(TRANSFEROUT_MOVETYPE.UNMOVEOUT, peopleTypeProps, referenceIDProps, contractID);
		}
		history.push(path);
	};

	// 編輯會籍移出合約 icon
	const handleEditOnClick = ({ contractID }) => {
		const path = CLUB_DOCUMENTS_ROUTER.TRANSFEROUT.GET_CONTRACT_PATH(TRANSFEROUT_MOVETYPE.UNMOVEOUT, peopleTypeProps, referenceIDProps, contractID);
		history.push(path);
	};

	// 下載 icon
	const handleDownloadPDFOnClick = rowData => {
		const { mainID, contractID, contractUrl } = rowData;
		doTransferOverPDFApi({ memberID: referenceIDProps, mainID, contractID, contractUrl });
	};

	const handleTransferOutConfirm = rowData => {
		membershipTransferOutDialogBoxRef.current.openMembershipTransferOutMoveOutDialog({ ...rowData, memberID: referenceIDProps }, onReload);
	};

	// 下載PDF API
	const doTransferOverPDFApi = async params => {
		await downloadTransferOutPDFApi(params);
	};

	// 刪除暫停合約資料
	const doDeleteApi = async rowData => {
		const { isTemporary, contractID } = rowData;
		let resp;
		if (isTemporary) {
			resp = await deleteDocTemporaryTransferOutContractApi({
				type: peopleTypeProps,
				id: referenceIDProps
			});
		} else {
			resp = await deleteTransferOutContractApi(contractID);
		}
		return resp;
	};

	return (
		<React.Fragment>
			<Tablenization cardProps={{ className: className }}>
				<Tablenization.TableRowHeader headerRow={labelTitle.current} />
				<Tablenization.TableRowBody
					headerRow={labelTitle.current}
					rowsData={sourceData}
					onTransferOutConfirm={handleTransferOutConfirm}
					onReviewEvent={handleReviewOnClick}
					onEditEvent={handleEditOnClick}
					onDownloadPDFEvent={handleDownloadPDFOnClick}
					onDeleteOnEvent={rowData => {
						membershipTransferOutDialogBoxRef.current.openConfirmDeleteDocDialog({ ...rowData, doDeleteApi }, onReload);
					}}
				/>
			</Tablenization>
			<MembershipTransferOutDialogBox ref={membershipTransferOutDialogBoxRef} />
		</React.Fragment>
	);
};

export default MembershipTransferOutHistoryTable;
